import React, { useEffect, useState, useRef } from "react";
import {
    Box,
    Typography,
    Card,
    Button,
    IconButton,
    Stack,
    Autocomplete,
    TextField,
    Pagination,
    PaginationItem
} from "@mui/material";
import {
    useParams
} from "react-router-dom";
import { useNavigate } from "react-router";
import { useLoader } from "../../pages/LoaderContext";
import { makeStyles } from '@mui/styles';
import { useAppContext } from "../../hooks/context/AppContext";

import { ToastContainer } from "react-toastify";
import { successToast } from "../utils/toast";
import circleArrowIcon from "../../assets/images/circle-arrow-icon.svg"
import downloadIcon from "../../assets/images/download-archive-icon.svg"
import alertIcon from "../../assets/images/alert.png";
import bulbIcon from "../../assets/images/bulb-light-icon.svg";
import { useHistoryApiClient } from "../Services/api/HistoryService";


import '../pages/styles/home.css';
import { projectVersion } from "config/navConfig";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { formatChangeLogData } from "./ChangeLogTable";


// Define TypeScript interfaces
interface VersionOption {
    key: string | number;
    value: string;
}
interface ArchivedItem {
    Version_Id: number;
    Version_Name: string;
    Version_Created_Date: string;
    Updated_By: string;
    [key: string]: any; // allows additional keys safely
}

interface ArchiveApiResponse {
    currentPage: number;
    totalPages: number;
    perPage: number;
    data: ArchivedItem[];
}

const useStyles = makeStyles({
    themeButton: {
        backgroundColor: '#2a3fbf !important',
        padding: "8px 30px",
        fontWeight: "700",
        '&:hover': { backgroundColor: '#2a3fbf !important' },
    },
    cancelButton: {
        backgroundColor: "#d9d9d9 !important",
        color: "#626262 !important",
        padding: "8px 30px",
        fontWeight: "700",
        '&:hover': { backgroundColor: '#d9d9d9 !important', color: '#626262 !important' },
    }
});



// Mock data for change logs table
const changeLogsData = [
    { id: 1, module: "Project Information", property: "SC Lead", newValue: "Avi", oldValue: "Daoud", changeDate: "01/09/2025 11:35 am" },
    { id: 2, module: "", property: "Project Status", newValue: "In-Active", oldValue: "Active", changeDate: "01/09/2025 11:55 am" },
    { id: 3, module: "", property: "Launch Quarter", newValue: "Q3", oldValue: "Q4", changeDate: "01/09/2025 11:58 am" },
    { id: 4, module: "", property: "Format", newValue: "Beads", oldValue: "Bars", changeDate: "01/09/2025 12:05 pm" },
    { id: 5, module: "", property: "Innoflex", newValue: "Explore, Execute", oldValue: "Pre start Explore, Execute", changeDate: "01/09/2025 12:35 pm" },
    { id: 6, module: "", property: "SC Phase", newValue: "Scoping, Design", oldValue: "Scoping, Design, Build", changeDate: "01/09/2025 12:46 pm" },
    { id: 7, module: "Milestones", property: "SIW Launch Week", newValue: "Q3", oldValue: "", changeDate: "01/09/2025 12:59 pm" },
    { id: 8, module: "", property: "BC Sign Off / CP Comment", newValue: "BC simulated 39.94% GM with opportunity for Turkey to improve GSP", oldValue: "BC simulated 41.25% GM with opportunity for Turkey to improve GSP", changeDate: "01/09/2025 01:15 pm" },
    { id: 9, module: "", property: "Network Risk", newValue: "High", oldValue: "Medium", changeDate: "01/09/2025 01:35 pm" },
    { id: 10, module: "BC Information", property: "Y1 GM", newValue: "39.9 %", oldValue: "38.7 %", changeDate: "01/09/2025 01:48 pm" },
    { id: 11, module: "", property: "Payback", newValue: "2 Years", oldValue: "2.2 Years", changeDate: "01/09/2025 01:56 pm" },
    { id: 12, module: "Technical Scope", property: "Formulation: New Goodies", newValue: "No", oldValue: "Yes", changeDate: "01/09/2025 02:15 pm" },
    { id: 13, module: "", property: "Packaging: Format", newValue: "Bottle", oldValue: "Pouch", changeDate: "01/09/2025 02:27 pm" },
    { id: 14, module: "Planning Strategy", property: "In-House: Sourcing Unit Country", newValue: "China", oldValue: "Brazil", changeDate: "01/09/2025 02:32 pm" },
    { id: 15, module: "", property: "CPT Compliance", newValue: "Yes", oldValue: "No", changeDate: "01/09/2025 02:49 pm" },
    { id: 16, module: "Engineering Scope", property: "Making Scope", newValue: "No Change", oldValue: "New Plant", changeDate: "01/09/2025 03:01 pm" },
    { id: 17, module: "", property: "EOL Scope", newValue: "No Change", oldValue: "Mods to Existing", changeDate: "01/09/2025 03:14 pm" },
    { id: 18, module: "", property: "Manufacturing Technical Risk", newValue: "Low", oldValue: "Medium", changeDate: "01/09/2025 03:15 pm" },
    { id: 19, module: "Procurement", property: "Supplier", newValue: "Existing", oldValue: "New", changeDate: "01/09/2025 04:35 pm" },
    { id: 20, module: "", property: "CM Onboarded", newValue: "Yes", oldValue: "No", changeDate: "01/09/2025 04:55 pm" },
    { id: 21, module: "SHEQ / Sustainability", property: "SEAC Risk", newValue: "No", oldValue: "Yes", changeDate: "01/09/2025 06:56 pm" },
    { id: 22, module: "", property: "Technical Risk Assessment", newValue: "No", oldValue: "Yes", changeDate: "01/09/2025 07:15 pm" },
    { id: 23, module: "Logistics", property: "Shipment Requirement", newValue: "Humidity Control", oldValue: "Dry", changeDate: "01/09/2025 08:35 pm" },
    { id: 24, module: "", property: "Logistics Risk", newValue: "Low", oldValue: "Medium", changeDate: "01/09/2025 09:26 pm" },
];

const ChangeHistory: React.FC = () => {
    const { appData, updateAppData, userData } = useAppContext();
    const [isDisabled, setIsDisabled] = useState(true);
    const { loading, setLoading } = useLoader();
    const { getVersionList, getArchieveList, getHistoryist, restoreData } = useHistoryApiClient();
    const { projectId, projectKey } = useParams<{ projectKey: string; projectId: string }>();
    const [isArchived, setIsArchived] = useState(false);
    const [isRestoreDialogOpen, setIsRestoreDialogOpen] = useState(false);
    const [selectedVersion, setSelectedVersion] = useState<VersionOption | null>(null);

    // Pagination states for archive table
    const [archivePage, setArchivePage] = useState(1); // Start from page 1 for API
    const [archiveTotalPages, setArchiveTotalPages] = useState(0);
    const [archieveList, setArchieveList] = useState<ArchivedItem[]>([]);

    // Pagination states for change logs table
    const [changeLogsPage, setChangeLogsPage] = useState(0);
    const [changeLogsRowsPerPage, setChangeLogsRowsPerPage] = useState(10);
    const [changeLogsTotalPages, setChangeLogsTotalPages] = useState(0);

    const navigate = useNavigate();
    const classes = useStyles();

    // Calculate pagination for change logs data
    const changeLogsStartIndex = changeLogsPage * changeLogsRowsPerPage;
    const changeLogsEndIndex = changeLogsStartIndex + changeLogsRowsPerPage;
    const currentChangeLogsData = changeLogsData.slice(changeLogsStartIndex, changeLogsEndIndex);
    const [versionList, setVersionList] = useState<VersionOption[]>([]);
    const [historyList, setHistoryList] = useState([]);


    useEffect(() => {
        fetchHistoryVersion()
        fetchArchieve(1) // Fetch first page initially
    }, [projectKey]);

    useEffect(() => {
        if (userData) {
            setIsDisabled(!userData.permissions.CanEdit);
        }
    }, [userData]);

    useEffect(() => {
        // Calculate total pages for change logs
        setChangeLogsTotalPages(Math.ceil(changeLogsData.length / changeLogsRowsPerPage));
    }, [changeLogsRowsPerPage]);

    const fetchHistoryVersion = async () => {
        try {
            setLoading(true);

            const data = await getVersionList(projectKey);
            const output: VersionOption[] =
                data?.snapShotResponse?.map((item: any) => ({
                    key: item.Version_Id,
                    value: item.Version_Name,
                })) || [];

            setVersionList(output);

            if (output.length > 0) {
                const firstVersion = output[0];
                setSelectedVersion(firstVersion);
                fetchHistory(firstVersion.key);
            }

        } catch (error) {
            console.error("Failed to fetch files:", error);
        } finally {
            setLoading(false);
        }
    };


    const fetchArchieve = async (page: number = 1) => {
        try {
            setLoading(true);
            // Check what parameters your getArchieveList function expects
            // If it expects 3 parameters, you might need to pass pageSize as the third parameter
            const data: ArchiveApiResponse = await getArchieveList(projectKey, page, 10); // 10 is pageSize
            setArchieveList(data.data);
            setArchiveTotalPages(data.totalPages);
            setArchivePage(data.currentPage);
            setLoading(false);
        } catch (error) {
            console.error("Failed to fetch archive:", error);
            setLoading(false);
        }
    };

    const fetchHistory = async (version: any) => {
        try {
            setLoading(true)
            const data = await getHistoryist(version, projectKey);
            setLoading(false)
            setHistoryList(data.result)
        } catch (error) {
            console.error("Failed to fetch files:", error);
        } finally {
        }
    };

    let handleBack = () => {
        navigate(`${projectVersion}/project/project-info/${projectId}/${projectKey}`)
    }

    let handleRestore = async () => {
        setIsRestoreDialogOpen(false)
        setLoading(true)
        // @ts-ignore
        let restore = await restoreData(selectedVersion.key, projectKey)
        setLoading(false)
        successToast(restore.message);
    }

    const handleArchivePageChange = (event: React.ChangeEvent<unknown>, newPage: number) => {
        setArchivePage(newPage);
        fetchArchieve(newPage); // Fetch new page from API
    };

    const handleChangeLogsPageChange = (event: React.ChangeEvent<unknown>, newPage: number) => {
        setChangeLogsPage(newPage - 1); // Convert to zero-based
    };

    // Handle version selection
    const handleVersionChange = (event: React.SyntheticEvent, newValue: VersionOption | null) => {
        setSelectedVersion(newValue);
        if (newValue) {
            fetchHistory(newValue.key)
        }
    };

    const parseIfJSON = (value: any) => {
        if (typeof value === "string") {
            try {
                return JSON.parse(value);
            } catch {
                return value;
            }
        }
        return value;
    };

    // Format date for display
    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB') + ' ' + date.toLocaleTimeString('en-GB', { 
            hour: '2-digit', 
            minute: '2-digit',
            hour12: true 
        });
    };

    // Calculate serial number based on page and index
    const getSerialNumber = (index: number) => {
        return (archivePage - 1) * 10 + index + 1; // Assuming 10 items per page
    };

    return (
        <>
            <ToastContainer />
            <div className="create-project-content">
                <Card className="" sx={{ padding: "30px", borderRadius: "20px", pt: 3 }}>
                    <Box>
                        <div className="card-head-wps">
                            <div className="back-button-wap">
                                {
                                    isArchived ?
                                        <Button onClick={() => setIsArchived(false)} sx={{ border: '0px', fontSize: '14px', color: '#B5B5B5', p: 0, textTransform: 'capitalize' }}><img src={circleArrowIcon} className="wtsback--img" /></Button>
                                        :
                                        <Button onClick={() => handleBack()} sx={{ border: '0px', fontSize: '14px', color: '#B5B5B5', p: 0, textTransform: 'capitalize' }}><img src={circleArrowIcon} className="wtsback--img" /> </Button>
                                }
                            </div>
                            {
                                !isArchived ?
                                    <div className="change-wp-log">
                                        <label className="txt-change-lgs">Change Logs</label>
                                        <div className="date-vm-select">
                                            <Autocomplete
                                                options={versionList}
                                                value={selectedVersion}
                                                onChange={handleVersionChange}
                                                getOptionLabel={(option: VersionOption) => option.value || ""}
                                                isOptionEqualToValue={(option: VersionOption, value: VersionOption) => option.key === value?.key}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        placeholder="Select version"
                                                        sx={{
                                                            '& .MuiOutlinedInput-root': {
                                                                borderRadius: '8px',
                                                                backgroundColor: '#fff',
                                                                minHeight: '32px',
                                                                '& input': {
                                                                    padding: '4px 8px',
                                                                    fontSize: '13px',
                                                                    height: '20px',
                                                                },
                                                                '& fieldset': {
                                                                    borderColor: '#ddd',
                                                                },
                                                                '&:hover fieldset': {
                                                                    borderColor: '#2A3FBF',
                                                                },
                                                                '&.Mui-focused fieldset': {
                                                                    borderColor: '#2A3FBF',
                                                                },
                                                            },
                                                        }}
                                                    />
                                                )}
                                                renderOption={(props, option: VersionOption) => (
                                                    <li {...props} className="item-option-wts">
                                                        <span className="drop-btn-opt">
                                                            <span className="optn-vers-txt">{option.value}</span>
                                                        </span>
                                                    </li>
                                                )}
                                                sx={{
                                                    width: '100%',
                                                    '& .MuiAutocomplete-inputRoot': {
                                                        padding: '0px !important',
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div className="restore-wp">
                                            <Button
                                                onClick={() => setIsRestoreDialogOpen(true)}
                                                sx={{
                                                    borderRadius: '30px', px: 4, py: 1, textTransform: 'capitalize', color: 'white !important',
                                                    backgroundColor: `${!selectedVersion || isDisabled ? '#d9d9d9 !important' : '#2a3fbf !important'}`

                                                }}
                                                disabled={!selectedVersion || isDisabled } // Disable if no version selected
                                            >
                                                Restore
                                            </Button>
                                        </div>
                                    </div>
                                    :
                                    null
                            }

                            {
                                !isArchived ?
                                    <div className="last-side-archive">
                                        <Button onClick={() => setIsArchived(true)} sx={{ border: '1px solid #2A3FBF', fontSize: '14px', color: '#2A3FBF', width: '130px', textTransform: 'capitalize', borderRadius: '30px' }}> Archives</Button>
                                    </div>
                                    :
                                    null
                            }
                        </div>

                        <div className="table-boxcard-project">
                            {
                                isArchived ?
                                    <>
                                        <div className="table-project-archive">
                                            <table className="table project-archive-table">
                                                <thead className="thead-project-arch">
                                                    <tr>
                                                        <th>S.No</th>
                                                        <th>Version</th>
                                                        <th>Version Date</th>
                                                        <th>Last Changed by</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="tbody-project-arch">
                                                    {archieveList.map((item: ArchivedItem, index: number) => (
                                                        <tr key={item.Version_Id}>
                                                            <td>{getSerialNumber(index)}</td>
                                                            <td>{item.Version_Name}</td>
                                                            <td>{formatDate(item.Version_Created_Date)    }</td>
                                                            <td>{item.Updated_By}</td>
                                                            <td>
                                                                <div className="download-button">
                                                                    <Button onClick={() => window.open(`${process.env.REACT_APP_BACKEND}/snapshots/export/${projectKey}/${item.Version_Id}`, "_blank")} sx={{ color: '#2A3FBF', fontSize: '14px', textTransform: 'capitalize' }}>
                                                                        <img src={downloadIcon} className="download-icon-img" />Download
                                                                    </Button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Archive Pagination - Only show if there are multiple pages */}
                                        {archiveTotalPages > 1 && (
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    padding: "20px",
                                                    width: "100%",
                                                }}
                                            >
                                                <Pagination
                                                    count={archiveTotalPages}
                                                    page={archivePage}
                                                    onChange={handleArchivePageChange}
                                                    siblingCount={1}
                                                    boundaryCount={1}
                                                    showFirstButton
                                                    showLastButton
                                                    renderItem={(item) => <PaginationItem {...item} />}
                                                />
                                            </Box>
                                        )}
                                    </>
                                    :
                                    <>
                                        <div className="table-project-info">
                                            <table className="table project-wap-table change-history-table">
                                                <thead className="thead-project-wap">
                                                    <tr>
                                                        <th className="wrap-text">Module</th>
                                                        <th className="wrap-text">Property</th>
                                                        <th className="wrap-text">New Value</th>
                                                        <th className="wrap-text">
                                                            Old Value {selectedVersion?.value ? `( ${selectedVersion.value} )` : ""}
                                                            <span className="sml-txt-vhead"></span>
                                                        </th>
                                                        <th className="wrap-text">Change Type</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="tbody-project-wap">
                                                    {formatChangeLogData(historyList).map((item: any) => {
                                                        console.log("itemddt->", item.newValue, typeof parseIfJSON(item.newValue))
                                                        return (
                                                            <tr key={item.id}>
                                                                <td className="wrap-text">{item.module}</td>
                                                                <td className="wrap-text">{item.property}</td>
                                                                <td className="wrap-text">
                                                                    {(() => {
                                                                        const value = parseIfJSON(item.newValue);

                                                                        if (typeof value === "object" && value !== null) {
                                                                            return Object.entries(value).map(([key, val], index, arr) => (
                                                                                <React.Fragment key={index}>
                                                                                    {key}: {String(val)}
                                                                                    {index < arr.length - 1 && ','}
                                                                                    <br />
                                                                                </React.Fragment>
                                                                            ));
                                                                        } else {
                                                                            return value;
                                                                        }
                                                                    })()}
                                                                </td>

                                                                <td className="wrap-text">
                                                                    {(() => {
                                                                        const value = parseIfJSON(item.oldValue);

                                                                        if (typeof value === "object" && value !== null) {
                                                                            return Object.entries(value).map(([key, val], index, arr) => (
                                                                                <React.Fragment key={index}>
                                                                                    {key}: {String(val)}
                                                                                    {index < arr.length - 1 && ','}
                                                                                    <br />
                                                                                </React.Fragment>
                                                                            ));
                                                                        } else {
                                                                            return value;
                                                                        }
                                                                    })()}
                                                                </td>


                                                                <td className="wrap-text">{item.changeType}</td>
                                                            </tr>
                                                        )
                                                    }

                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                            }
                        </div>
                    </Box>
                </Card>
            </div>

            <Dialog open={isRestoreDialogOpen} onClose={() => setIsRestoreDialogOpen(false)} >
                <DialogTitle>
                    <h3 className="modal-title">Confirm Restore</h3>
                </DialogTitle>
                <hr></hr>
                <DialogContent>
                    <div className="save-card-wapper">
                        <div className="alert-icon-wp">
                            <img src={alertIcon} alt="" />
                        </div>
                        <h2 className="title-save-frm"></h2>
                        <div className="txt-flex--mt">
                            <span className="bulb-txt"><img src={bulbIcon} alt="" /></span>
                            <p>Are you sure you want to restore it?</p>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button className="btn-cancel" onClick={() => setIsRestoreDialogOpen(false)}>
                        Cancel
                    </Button>
                    <Button
                        onClick={handleRestore}
                        className="btn-delete"
                        variant="contained"
                    >
                        Restore
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default ChangeHistory;